import { useLocation } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import React, { useState, useMemo, useEffect } from "react";

/* ================= IMPORT IMAGES ================= */
import p1 from "../assets/p1.PNG";
import p2 from "../assets/p2.PNG";
import p3 from "../assets/p3.png";
import p4 from "../assets/p4.png";
import p5 from "../assets/p5.PNG";
import p6 from "../assets/p6.PNG";
import p7 from "../assets/p7.PNG";
import p8 from "../assets/p8.PNG";
import p9 from "../assets/p9.PNG";
import p10 from "../assets/p10.PNG";
import p11 from "../assets/p11.PNG";
import p12 from "../assets/p12.PNG";
import p13 from "../assets/p13.PNG";
import p14 from "../assets/p14.PNG";
import p15 from "../assets/p15.PNG";
import p16 from "../assets/p16.PNG";
import p17 from "../assets/p17.PNG";
import p18 from "../assets/p18.png";
import p19 from "../assets/p19.PNG";
import p20 from "../assets/p20.PNG";
import p21 from "../assets/p21.PNG";
import p22 from "../assets/p22.PNG";
import p23 from "../assets/p23.PNG";
import p24 from "../assets/p24.PNG";
import p25 from "../assets/p25.PNG";
import p26 from "../assets/p26.PNG";
import p27 from "../assets/p27.PNG";
import p28 from "../assets/p28.PNG";
import p29 from "../assets/p29.PNG";
import p30 from "../assets/p30.PNG";
import p31 from "../assets/p31.PNG";
import p32 from "../assets/p32.PNG";
import p33 from "../assets/p33.PNG";
import p34 from "../assets/p34.PNG";
import p35 from "../assets/p35.PNG";
import p36 from "../assets/p36.PNG";
import p37 from "../assets/p37.PNG";
import p38 from "../assets/p38.PNG";
import p39 from "../assets/p39.PNG";
import p40 from "../assets/p40.PNG";
import p41 from "../assets/p41.PNG";
import p42 from "../assets/p42.PNG";
import p43 from "../assets/p43.PNG";
import p44 from "../assets/p44.PNG";
import p45 from "../assets/p45.PNG";
import p46 from "../assets/p46.PNG";
import p47 from "../assets/p47.PNG";
import p48 from "../assets/p48.PNG";
import p49 from "../assets/p49.PNG";
import p50 from "../assets/p50.PNG";
import p51 from "../assets/p51.PNG";
import p52 from "../assets/p52.PNG";
import p53 from "../assets/p53.PNG";
import p54 from "../assets/p54.PNG";
import p55 from "../assets/p55.PNG";
import p56 from "../assets/p56.PNG";
import p57 from "../assets/p57.PNG";
import p58 from "../assets/p58.PNG";
import p59 from "../assets/p59.PNG";
import p60 from "../assets/p60.PNG";
import p61 from "../assets/p61.PNG";
import p62 from "../assets/p62.PNG";
import p63 from "../assets/p63.PNG";
import p64 from "../assets/p64.PNG";
import p65 from "../assets/p65.PNG";
import p66 from "../assets/p66.PNG";
import p67 from "../assets/p67.PNG";
import p68 from "../assets/p68.PNG";
import p69 from "../assets/p69.PNG";
import p70 from "../assets/p70.PNG";
import p71 from "../assets/p71.PNG";
import p72 from "../assets/p72.PNG";
import p73 from "../assets/p73.PNG";
import p74 from "../assets/p74.PNG";
import p75 from "../assets/p75.PNG";
import p76 from "../assets/p76.PNG";
import p77 from "../assets/p77.PNG";
import p78 from "../assets/p78.PNG";
import p79 from "../assets/p79.PNG";
import p80 from "../assets/p80.PNG";
import p81 from "../assets/p81.PNG";
import p82 from "../assets/p82.PNG";
import p83 from "../assets/p83.PNG";
import p84 from "../assets/p84.PNG";
import p85 from "../assets/p85.PNG";
import p86 from "../assets/p86.PNG";
import p87 from "../assets/p87.PNG";

/* ================= DATA ================= */
const allProducts = [
  { id: 1, name: "Diamond Tennis Bracelet", price: 1, oldPrice: 40, category: "Bracelets", image: p1, tag: "SALE", rating: 5, reviews: 38 },
  { id: 2, name: "Rose Petal Diamond Ring", price: 2850, oldPrice: 3200, category: "Rings", image: p2, tag: "BESTSELLER", rating: 5, reviews: 128 },
  { id: 3, name: "Infinity Gold Bracelet", price: 1280, oldPrice: 1500, category: "Bracelets", image: p3, tag: "SALE", rating: 5, reviews: 112 },
  { id: 4, name: "Golden Vine Necklace", price: 2100, category: "Necklaces", image: p4, tag: "BESTSELLER", rating: 5, reviews: 156 },
  { id: 5, name: "Celestial Pearl Necklace", price: 1650, category: "Necklaces", image: p5, tag: "NEW", rating: 5, reviews: 94 },
  { id: 6, name: "Moonlight Sapphire Ring", price: 3450, category: "Rings", image: p6, tag: "NEW", rating: 5, reviews: 45 },
  { id: 7, name: "Aurora Drop Earrings", price: 980, category: "Earrings", image: p7, tag: "NEW", rating: 5, reviews: 67 },
  { id: 8, name: "Vintage Lace Earrings", price: 760, category: "Earrings", image: p8, tag: "", rating: 5, reviews: 83 },
  { id: 9, name: "Luxury Clover Necklace", price: 760, category: "Earrings", image: p9, tag: "", rating: 5, reviews: 83 },

  { id: 10, name: "Elegant Gold Ring", price: 1890, oldPrice: 2200, category: "Rings", image: p10, tag: "NEW", rating: 5, reviews: 91 },
  { id: 11, name: "Crystal Charm Necklace", price: 2450, oldPrice: 2800, category: "Necklaces", image: p11, tag: "SALE", rating: 5, reviews: 74 },
  { id: 12, name: "Pearl Bloom Earrings", price: 950, oldPrice: 1200, category: "Earrings", image: p12, tag: "BESTSELLER", rating: 5, reviews: 102 },
  { id: 13, name: "Royal Tennis Bracelet", price: 1350, oldPrice: 1600, category: "Bracelets", image: p13, tag: "", rating: 5, reviews: 67 },
  { id: 14, name: "Butterfly Diamond Ring", price: 2990, oldPrice: 3400, category: "Rings", image: p14, tag: "NEW", rating: 5, reviews: 120 },
  { id: 15, name: "Classic Pearl Necklace", price: 1780, oldPrice: 2100, category: "Necklaces", image: p15, tag: "", rating: 5, reviews: 81 },
  { id: 16, name: "Twinkle Stud Earrings", price: 890, oldPrice: 1100, category: "Earrings", image: p16, tag: "SALE", rating: 5, reviews: 95 },
  { id: 17, name: "Infinity Charm Bracelet", price: 1490, oldPrice: 1800, category: "Bracelets", image: p17, tag: "BESTSELLER", rating: 5, reviews: 114 },
  { id: 18, name: "Rose Gold Ring", price: 2590, oldPrice: 2900, category: "Rings", image: p18, tag: "", rating: 5, reviews: 88 },
  { id: 19, name: "Heart Pendant Necklace", price: 1990, oldPrice: 2300, category: "Necklaces", image: p19, tag: "NEW", rating: 5, reviews: 93 },
  { id: 20, name: "Shine Drop Earrings", price: 990, oldPrice: 1250, category: "Earrings", image: p20, tag: "", rating: 5, reviews: 59 },
  { id: 21, name: "Luxury Chain Bracelet", price: 1650, oldPrice: 1900, category: "Bracelets", image: p21, tag: "SALE", rating: 5, reviews: 110 },
  { id: 22, name: "Princess Diamond Ring", price: 3190, oldPrice: 3600, category: "Rings", image: p22, tag: "BESTSELLER", rating: 5, reviews: 142 },
  { id: 23, name: "Elegant Pearl Necklace", price: 1850, oldPrice: 2200, category: "Necklaces", image: p23, tag: "", rating: 5, reviews: 76 },
  { id: 24, name: "Silver Leaf Earrings", price: 820, oldPrice: 980, category: "Earrings", image: p24, tag: "NEW", rating: 5, reviews: 69 },
  { id: 25, name: "Golden Love Bracelet", price: 1540, oldPrice: 1800, category: "Bracelets", image: p25, tag: "", rating: 5, reviews: 98 },
  { id: 26, name: "Luxury Crown Ring", price: 2890, oldPrice: 3250, category: "Rings", image: p26, tag: "SALE", rating: 5, reviews: 107 },
  { id: 27, name: "Crystal Heart Necklace", price: 2090, oldPrice: 2450, category: "Necklaces", image: p27, tag: "BESTSELLER", rating: 5, reviews: 115 },
  { id: 28, name: "Elegant Hoop Earrings", price: 940, oldPrice: 1150, category: "Earrings", image: p28, tag: "", rating: 5, reviews: 80 },
  { id: 29, name: "Rose Charm Bracelet", price: 1420, oldPrice: 1700, category: "Bracelets", image: p29, tag: "NEW", rating: 5, reviews: 72 },
  { id: 30, name: "Diamond Halo Ring", price: 3390, oldPrice: 3800, category: "Rings", image: p30, tag: "", rating: 5, reviews: 132 },
  { id: 31, name: "Moon Pendant Necklace", price: 1950, oldPrice: 2250, category: "Necklaces", image: p31, tag: "SALE", rating: 5, reviews: 97 },
  { id: 32, name: "Crystal Stud Earrings", price: 780, oldPrice: 990, category: "Earrings", image: p32, tag: "", rating: 5, reviews: 62 },
  { id: 33, name: "Luxury Pearl Bracelet", price: 1680, oldPrice: 1950, category: "Bracelets", image: p33, tag: "BESTSELLER", rating: 5, reviews: 101 },
  { id: 34, name: "Royal Sapphire Ring", price: 3590, oldPrice: 3990, category: "Rings", image: p34, tag: "NEW", rating: 5, reviews: 118 },
  { id: 35, name: "Vintage Charm Necklace", price: 2180, oldPrice: 2480, category: "Necklaces", image: p35, tag: "", rating: 5, reviews: 84 },
  { id: 36, name: "Diamond Bloom Earrings", price: 990, oldPrice: 1190, category: "Earrings", image: p36, tag: "SALE", rating: 5, reviews: 91 },
  { id: 37, name: "Elegant Chain Bracelet", price: 1580, oldPrice: 1850, category: "Bracelets", image: p37, tag: "", rating: 5, reviews: 79 },
  { id: 38, name: "Luxury Solitaire Ring", price: 3750, oldPrice: 4200, category: "Rings", image: p38, tag: "BESTSELLER", rating: 5, reviews: 150 },
  { id: 39, name: "Golden Heart Necklace", price: 2250, oldPrice: 2600, category: "Necklaces", image: p39, tag: "", rating: 5, reviews: 88 },
  { id: 40, name: "Luxury Pearl Earrings", price: 1150, oldPrice: 1390, category: "Earrings", image: p40, tag: "NEW", rating: 5, reviews: 74 },
  { id: 41, name: "Diamond Charm Bracelet", price: 1720, oldPrice: 2050, category: "Bracelets", image: p41, tag: "", rating: 5, reviews: 95 },
  { id: 42, name: "Luxury Emerald Ring", price: 3890, oldPrice: 4350, category: "Rings", image: p42, tag: "SALE", rating: 5, reviews: 126 },
  { id: 43, name: "Elegant Clover Necklace", price: 2120, oldPrice: 2450, category: "Necklaces", image: p43, tag: "BESTSELLER", rating: 5, reviews: 103 },
  { id: 44, name: "Classic Diamond Earrings", price: 1080, oldPrice: 1290, category: "Earrings", image: p44, tag: "", rating: 5, reviews: 86 },
  { id: 45, name: "Luxury Gold Bracelet", price: 1820, oldPrice: 2150, category: "Bracelets", image: p45, tag: "NEW", rating: 5, reviews: 92 },
  { id: 46, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p46, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 47, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p47, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 48, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p48, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 49, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p49, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 50, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p50, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 51, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p51, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 52, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p52, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 53, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p53, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 54, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p54, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 55, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p55, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 56, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p56, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 57, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p57, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 58, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p58, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 59, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p59, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 60, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p60, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 61, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p61, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 62, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p62, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 63, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p63, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 64, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p64, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 65, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p65, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 66, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p66, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 67, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p67, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 68, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p68, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 69, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p69, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 70, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p70, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 71, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p71, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 72, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p72, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 73, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p73, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 74, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p74, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 75, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p75, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 76, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p76, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 77, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p77, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 78, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p78, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 79, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p79, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 80, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p80, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 81, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p81, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 82, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p82, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 83, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p83, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 84, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p84, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 85, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p85, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 86, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p86, tag: "BESTSELLER", rating: 5, reviews: 165 },
  { id: 87, name: "Royal Diamond Ring", price: 4100, oldPrice: 4500, category: "Rings", image: p87, tag: "BESTSELLER", rating: 5, reviews: 165 },
];

const categories = [
  "All Jewelry",
  "Rings",
  "Necklaces",
  "Earrings",
  "Bracelets",
];

const PRODUCTS_PER_PAGE = 9;

const Products = () => {
  const location = useLocation();

  const [category, setCategory] = useState("All Jewelry");
  const [sort, setSort] = useState("popular");
  const [maxPrice, setMaxPrice] = useState(5000);
  const [currentPage, setCurrentPage] = useState(1);

  /* ================= SEARCH PARAM ================= */
  const query = new URLSearchParams(location.search);
  const search = query.get("search")?.toLowerCase() || "";

  /* ================= FILTER + SORT ================= */
  const filtered = useMemo(() => {
    let data = [...allProducts];

    // 🔍 SEARCH
    if (search) {
      data = data.filter((p) =>
        p.name.toLowerCase().includes(search)
      );
    }

    // 📂 CATEGORY
    if (category !== "All Jewelry") {
      data = data.filter((p) => p.category === category);
    }

    // 💰 PRICE
    data = data.filter((p) => p.price <= maxPrice);

    // 🔃 SORT
    if (sort === "low") data.sort((a, b) => a.price - b.price);
    if (sort === "high") data.sort((a, b) => b.price - a.price);

    return data;
  }, [category, sort, maxPrice, search]);

  /* ================= RESET PAGE ================= */
  useEffect(() => {
    setCurrentPage(1);
  }, [category, sort, maxPrice, search]);

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filtered.length / PRODUCTS_PER_PAGE);

  const currentProducts = filtered.slice(
    (currentPage - 1) * PRODUCTS_PER_PAGE,
    currentPage * PRODUCTS_PER_PAGE
  );
  const [openPreview, setOpenPreview] = useState(false);

return (
  <div className="min-h-screen bg-gradient-to-b from-[#fdfaf8] via-[#F6F2EF] to-[#f3ece7]">

    {/* ================= HERO ================= */}
    <section className="relative overflow-hidden bg-gradient-to-r from-[#1b1b1b] via-[#2d2d2d] to-black py-24">

      <div className="absolute -top-24 -left-20 w-80 h-80 bg-[#e7b6a1]/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 right-0 w-96 h-96 bg-[#e7b6a1]/10 rounded-full blur-3xl"></div>

      <div className="relative text-center text-white px-6">

        <p className="uppercase tracking-[6px] text-[#e7b6a1] text-sm mb-4">
          Luxury Collection
        </p>

        <h1 className="text-5xl md:text-6xl font-serif">
          Fine Jewelry
        </h1>

        <p className="max-w-2xl mx-auto mt-6 text-gray-300 leading-8">
          Discover handcrafted luxury jewelry made with timeless elegance
          and premium craftsmanship.
        </p>

        {search && (
          <div className="inline-block mt-8 bg-[#e7b6a1] text-black px-6 py-3 rounded-full font-medium shadow-lg">
            Showing results for "{search}"
          </div>
        )}

      </div>
    </section>

    {/* ================= CONTENT ================= */}
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 flex flex-col lg:flex-row gap-10">

      {/* ================= SIDEBAR ================= */}
      <aside className="lg:w-72">

        <div className="sticky top-28 bg-white/80 backdrop-blur-xl rounded-3xl p-8 shadow-xl border border-white">

          <div className="flex justify-between items-center mb-8">
            <h2 className="font-serif text-2xl">
              Filters
            </h2>

            <span className="bg-black text-white px-3 py-1 rounded-full text-xs">
              {filtered.length}
            </span>
          </div>

          {/* CATEGORY */}

          <div className="mb-10">

            <h3 className="uppercase text-xs tracking-[4px] text-gray-400 mb-5">
              Category
            </h3>

            <div className="space-y-3">

              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setCategory(cat)}
                  className={`w-full text-left px-5 py-3 rounded-xl transition-all duration-300 ${
                    category === cat
                      ? "bg-black text-white shadow-lg"
                      : "bg-[#f8f4f2] hover:bg-[#e7b6a1] hover:text-black"
                  }`}
                >
                  {cat}
                </button>
              ))}

            </div>

          </div>

          {/* PRICE */}

          <div className="mb-10">

            <div className="flex justify-between mb-4">
              <h3 className="uppercase text-xs tracking-[4px] text-gray-400">
                Price
              </h3>

              <span className="font-semibold">
                ₹{maxPrice}
              </span>
            </div>

            <input
              type="range"
              min={0}
              max={5000}
              value={maxPrice}
              onChange={(e) => setMaxPrice(Number(e.target.value))}
              className="w-full accent-[#e7b6a1]"
            />

          </div>

          {/* SORT */}

          <div>

            <h3 className="uppercase text-xs tracking-[4px] text-gray-400 mb-5">
              Sort By
            </h3>

            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="w-full rounded-xl border px-4 py-3 bg-white"
            >
              <option value="popular">Most Popular</option>
              <option value="low">Price Low → High</option>
              <option value="high">Price High → Low</option>
            </select>

          </div>

        </div>

      </aside>

      {/* ================= PRODUCTS ================= */}

      <section className="flex-1">

        {filtered.length === 0 ? (

          <div className="text-center py-24">

            <h2 className="text-3xl font-serif">
              No Products Found
            </h2>

            <p className="text-gray-500 mt-3">
              Try changing filters or search keyword.
            </p>

          </div>

        ) : (

          <>

            <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-8">

              {currentProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                />
              ))}

            </div>

            {/* ================= PAGINATION ================= */}

            {totalPages > 1 && (

              <div className="flex justify-center items-center gap-3 mt-16 flex-wrap">

                <button
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-5 py-3 rounded-xl border bg-white hover:bg-black hover:text-white disabled:opacity-40"
                >
                  ← Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (

                  <button
                    key={i}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`w-12 h-12 rounded-xl transition ${
                      currentPage === i + 1
                        ? "bg-black text-white shadow-lg"
                        : "bg-white border hover:bg-[#e7b6a1]"
                    }`}
                  >
                    {i + 1}
                  </button>

                ))}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  className="px-5 py-3 rounded-xl border bg-white hover:bg-black hover:text-white disabled:opacity-40"
                >
                  Next →
                </button>

              </div>

            )}

          </>

        )}

      </section>

    </div>

  </div>
);
};

export default Products;